import type { FilterDataProperty, sortDirectionType } from 'components/CoinMarketTable/types';

export const getMarketsData = async (
	route: string,
	symbol: string,
	page = 1,
	perPage = 5,
	sortBy: FilterDataProperty = 'rank',
	order: sortDirectionType = 'asc',
	convertCurrency = 'USD',
) => {
	try {
		const res = await fetch(
			`/api/coin-data/markets-data?page=${page}&route=${route}&per-page=${perPage}&symbol=${symbol}&sort=${sortBy}&order=${order}&convert=${convertCurrency}`,
		);
		const { marketTableData } = await res.json();
		return marketTableData;
	} catch (e) {
		console.log('error occurred', e);
	}
};
